import ToastService from '@/modules/toasts/services/ToastService';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import axios from 'axios';

export default {
  data() {
    return {
      isFormValid: false,
      onFormComplete: false,
      isFormValidArray: [],
    };
  },
  /**
   * Properties to check if the information is returned from the api and render
   */
  computed: {
    hasProfileInfo() {
      return (
        this.me.prefix ||
        this.me.firstName ||
        this.me.middleName ||
        this.me.lastName ||
        this.me.suffix ||
        this.me.birthDate ||
        this.me.nickName
      );
    },
    hasWorkInfo() {
      return this.me.company || this.me.title;
    },
    hasOtherInfo() {
      return (
        this.me.pf1 ||
        this.me.pf2 ||
        this.me.pf3 ||
        this.me.pf4 ||
        this.me.pf5 ||
        this.me.pf6 ||
        this.me.pf7 ||
        this.me.pf8 ||
        this.me.suppressReceipt
      );
    },
    hasEmailInfo() {
      return this.me.emails && this.me.emails.length > 0;
    },
    hasPhonesInfo() {
      return this.me.phones && this.me.phones.length > 0;
    },
    hasAddressesInfo() {
      return this.me.addresses && this.me.addresses.length > 0;
    },
  },
  methods: {
    /**
     * Method to assign the form data from child
     * @param {Object} formData
     */
    processformUpdate(formData) {
      Object.assign(this.form, formData);
    },
    /**
     * Method to set the validity of form based on child forms
     * @param {Boolean} $event
     */
    formSave(isValid, name) {
      const index = this.isFormValidArray.findIndex(form => form.name === name);
      if (index === -1) this.isFormValidArray.push({ name, isValid });
      else this.isFormValidArray[index].isValid = isValid;
      this.isFormValid = this.isFormValidArray.every(formElt => formElt.isValid === true);
    },
    /**
     * Method to save the payload and post data
     */
    async save(payload) {
      if (this.me.prefix) this.me.prefix.value = this.form.prefix;
      if (this.me.firstName) this.me.firstName.value = this.form.firstName;
      if (this.me.middleName) this.me.middleName.value = this.form.middleName;
      if (this.me.nickName) this.me.nickName.value = this.form.nickname;
      if (this.me.lastName) this.me.lastName.value = this.form.lastName;
      if (this.me.suffix) this.me.suffix.value = this.form.suffix;
      if (this.me.birthDate) this.me.birthDate.value = this.form.birthDate;
      if (this.me.title) this.me.title.value = this.form.title;
      if (this.me.company) this.me.company.value = this.form.company;
      if (this.me.pf1) this.me.pf1.value = this.form.pf1;
      if (this.me.pf2) this.me.pf2.value = this.form.pf2;
      if (this.me.pf3) this.me.pf3.value = this.form.pf3;
      if (this.me.pf4) this.me.pf4.value = this.form.pf4;
      if (this.me.pf5) this.me.pf5.value = this.form.pf5;
      if (this.me.pf6) this.me.pf6.value = this.form.pf6;
      if (this.me.pf7) this.me.pf7.value = this.form.pf7;
      if (this.me.pf8) this.me.pf8.value = this.form.pf8;
      if (this.me.suppressReceipt) this.me.suppressReceipt.value = this.form.suppressReceipt;
      if (this.me.emails) this.me.emails = this.form.emails;
      if (this.me.phones) this.me.phones = this.form.phones;
      if (this.me.addresses) this.me.addresses = this.form.addresses;

      this.loading = true;

      try {
        const response = await axios.post('api/me', payload);

        if (response.data.code === 0) {
          const message = 'Account settings have been successfully updated';
          ToastService.open(WCSimpleToast, {
            props: {
              variant: 'success',
              title: 'Edit Success',
              message,
            },
            timeout: 7000,
          });
          this.onFormComplete = true;
        }
      } catch (error) {
        const response = error.response;
        const message =
          response && response.data && response.data.message
            ? response.data.message
            : 'Failed to save';
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: 'Error',
            message,
          },
          timeout: 7000,
        });
        this.onFormComplete = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
